import React from "react";
import { getStyled } from "@sf-core";
import { CardHeader } from "@mui/material";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import QuestionMenu from "./questionMenu";
import { Handle, Position, useNodes, useEdges } from "reactflow";
import { useTranslation } from "react-i18next";
import { StyledCard } from "./constants";
import SFTypography from "../../typography";

const { styled } = getStyled();

const StyledChildrenContainer = styled("div", { shouldForwardProp: false })(
  ({ theme }) => ({
    display: "flex",
    alignItems: "center",
    position: "absolute",
    bottom: "-5px",
    width: "100%",
  })
);

const StyledChildrenButton = styled("button", { shouldForwardProp: false })(
  ({ theme }) => ({
    fontSize: 7,
    padding: "2px 5px",
    margin: "0 auto",
    borderRadius: "10px",
    border: `1px ${theme.palette.grey200.main} solid`,
    background: theme.palette.grey200.main,
    cursor: "pointer",
  })
);

const Button = ({ id, type, data, toggleChildren, onEdit, ...rest }) => {
  const { t } = useTranslation();
  const nodes = useNodes();
  const edges = useEdges();

  return (
    <>
      <Handle type="target" position={Position.Top} style={{ opacity: 0 }} />
      <StyledCard hasError={!data.label} elevation={0}>
        <CardHeader
          disableTypography
          avatar={<TouchAppIcon />}
          title={
            <SFTypography variant="body1bold">
              {t("components.flowChart.nodes.button")}
            </SFTypography>
          }
          subheader={
            <SFTypography variant="body2" hasHtml>
              {data.label || t("components.flowChart.questions.missingContent")}
            </SFTypography>
          }
          action={
            <>
              {!data.disabled && (
                <QuestionMenu
                  onEdit={() =>
                    onEdit({ id, type, data, ...rest, nodes, edges })
                  }
                />
              )}
            </>
          }
        />
      </StyledCard>
      {type != "answer" && data.childrenCount > 0 && (
        <StyledChildrenContainer>
          <StyledChildrenButton onClick={toggleChildren.bind(this, id)}>
            {t("components.flowChart.questions.childrenCount", {
              count: data.childrenCount,
            })}
          </StyledChildrenButton>
        </StyledChildrenContainer>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        id="a"
        style={{ opacity: 0 }}
      />
    </>
  );
};

export default Button;
